import { Box, Grid, Typography } from "@mui/material";
import { EditIconButton } from "../../../app/components/iconButtons/EditIconButton";
import { Localized } from "@fluent/react";

export type FieldKey = "name" | "structureId" | "manufacturer" | "model" | "serialNo" 
    | "productionYear" | "supplier" | "description" | "isGxpRelevant";

type KeyValueRowProps = {
    field: FieldKey;
    label: React.ReactNode;
    value: React.ReactNode;
    multiline?: boolean;
    labelCols?: number; // domyślnie 2
    valueCols?: number; // domyślnie 10
    editable?: boolean;
    openEdit: (field: FieldKey, value?: React.ReactNode | null) => void;
};

export const KeyValueRow = ({
    field,
    label,
    value,
    multiline = false,
    labelCols = 2,
    valueCols = 10,
    editable = true,
    openEdit,
}: KeyValueRowProps) => (
    <Grid
        container
        spacing={1.5}
        alignItems="stretch"
        sx={{
            py: 0.75,
            borderBottom: (t) => `1px dashed ${t.palette.divider}`,
            "&:last-of-type": { borderBottom: "none" },
        }}
    >
        {/* label */}
        <Grid item xs={12} sm={labelCols}>
            <Box
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    border: `1px solid ${t.palette.grey[200]}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                })}
            >
                {/* jeśli label to string -> opakuj w Typography, w przeciwnym razie renderuj JSX */}
                {typeof label === "string" ? (
                    <Typography variant="body2" fontWeight={600} color="text.secondary">{label}</Typography>
                ) : (
                    label
                )}
            </Box>
        </Grid>

        {/* value */}
        <Grid item xs={12} sm={valueCols}>
            <Box
                sx={(t) => ({
                    border: `1px solid ${t.palette.grey[200]}`,
                    bgcolor: t.palette.grey[50],
                    borderRadius: 1,
                    px: 1.25,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                    justifyContent: "space-between",
                })}
            >
                <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={multiline ? { whiteSpace: "pre-line" } : undefined}
                >
                    {value}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        px: 0.5,
                        "&:hover .editIcon, &:focus-within .editIcon": {
                            color: "info.main",
                        },
                    }}
                >
                    {editable && (
                        <EditIconButton
                            tooltip={<Localized id='edit'>_edit</Localized>}
                            onClick={() => openEdit(field, value)}
                        />
                    )}
                </Box>
            </Box>
        </Grid>
    </Grid>
);